import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  enEsperaCfdiApi,
  type BuscarEnEsperaParams,
} from "@/features/en-espera-cfdi/services/en-espera-cfdi.api";

export const enEsperaCfdiQueryOptions = (params: BuscarEnEsperaParams = {}) =>
  queryOptions({
    queryKey: qk.enEsperaCfdi(params),
    queryFn: () => enEsperaCfdiApi.listar(params),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  });

export function useEnEsperaCfdi(params: BuscarEnEsperaParams = {}) {
  return useQuery(enEsperaCfdiQueryOptions(params));
}
